export default __webpack_public_path__ + "static/media/veqtor_pregunta.8de7c55f.svg";